import React from 'react';
import ReaderWrapper from '../ReaderWrapper';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    header: {
        fontWeight: '600',
    },
    downloadLink: {
        fontWeight: '500',
    },
};

class InfoReader extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <ReaderWrapper>
                <table>
                    <thead className={classes.header}>
                        <td>Operating System</td>
                        <td>Build Version</td>
                        <td>Build Date</td>
                        <td></td>
                    </thead>
                    <tr>
                        <td>Apple macOS</td>
                        <td>602</td>
                        <td>2019-07-19</td>
                        <td>
                            <a
                                id="download-flight-cli-mac"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight/cli/mac/flight_mac.zip'}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Linux (Red Hat/CentOS 7)</td>
                        <td>602</td>
                        <td>2019-07-19</td>
                        <td>
                            <a
                                id="download-flight-cli-linux-redhat-centos7"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight/cli/linux/flight_linux7.zip'}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Linux (Red Hat/CentOS 6)</td>
                        <td>602</td>
                        <td>2019-07-19</td>
                        <td>
                            <a
                                id="download-flight-cli-linux-redhat-centos6"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight/cli/linux/flight_linux6.zip'}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Microsoft Windows</td>
                        <td>602</td>
                        <td>2019-07-19</td>
                        <td>
                            <a
                                id="download-flight-cli-windows"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight/cli/windows/flight_windows.zip'}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                </table>
            </ReaderWrapper>
        );
    }
}

export default withStyles(styles)(InfoReader);
